import React from 'react';
import {ReactComponent as UserOutlined} from '../../styles/assets/UserIcon.svg'
import {ReactComponent as LogoutOutlined} from '../../styles/assets/SignOut.svg'
import {ReactComponent as ChangeOutlined} from '../../styles/assets//userManagement.svg'
import { FeatureFlag } from '../../factories/index'
import { LockOutlined, UserAddOutlined } from '@ant-design/icons'
interface propTypes{
  className?:string
  name?: string
  collapsed?:boolean
  email?: string
  logOut: ()=> void
}

const PopUpHover = (prop: propTypes)=> {
    const useProfileFF = new FeatureFlag(process.env.REACT_APP_USER_PROFILE)

    const logout = (e:React.MouseEvent)=>{
        e.preventDefault()
        e.stopPropagation()
        prop.logOut()
    }

    const userProfileComponent = () => (
        <div
          className='option'
          onClick={() => window.location.href = `${process.env.REACT_APP_UNIFY_ENV}/app/personal-info/view`}
        >
            <UserOutlined/>
            <p>Personal Info</p>
        </div>
    )

    /* const changePasswordComponent = () => (
        <div
          className='option'
          onClick={() => window.location.href = `${process.env.REACT_APP_UNIFY_ENV}/app/security-privacy/change-password `}
        >
            <ChangeOutlined/>
            <p>Change Password</p>
        </div>
    ) */

    const securityAndPrivacy = () => (
        <div
          className='option'
          onClick={() => window.location.href = `${process.env.REACT_APP_UNIFY_ENV}/app/security-privacy/list`}
        >
            <LockOutlined />
            <p>Security & Privacy</p>
        </div>
    )

    const inviteUser = () => (
        <div
          className='option'
          onClick={() => window.location.href = `${process.env.REACT_APP_UNIFY_ENV}/nav/invite`}
        >
            <UserAddOutlined />
            <p>Invite User</p>
        </div>
    )

    const isUserProfileEnable = () => useProfileFF.renderFlaggedComponent({ component: userProfileComponent })

    // const iscChangePasswordEnable = () => useProfileFF.renderFlaggedComponent({ component: changePasswordComponent })

    return(
        <div  className={prop.className}>
            {prop.collapsed &&
                <div className='user-info'>
                    <p className='name'>{prop.name}</p>
                    <p className='email'>{prop.email}</p>
                </div>
            }
            { isUserProfileEnable() }
            { inviteUser() }
            {/* { iscChangePasswordEnable() } */}
            { securityAndPrivacy() }
            <div onClick={logout} className='option'>
                <LogoutOutlined/>
                <p>Sign out</p>
            </div>
        </div>
    ) 
}

export default PopUpHover
